import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { addMinutes, addSeconds } from 'date-fns';
import { Subscription, timer } from 'rxjs';
import { Router } from '@angular/router';

import { SecurityService } from '../security/security.service';
import { InactivityTimeoutComponent } from './inactivity-timeout.component';

@Injectable({ providedIn: 'root' })
export class InactivityTimeoutService {

    private modal = inject(NgbModal);
    private sec = inject(SecurityService);
    private router = inject(Router);

	subsriptions = new Subscription();
	modalOpen = false;

	constructor() { this.startTimer(); }

	startTimer() {
		const source = timer(0, 1000);
		this.subsriptions.add(
			source.subscribe(() => {
				const user = this.sec.getUser();
				this.handleUserTimeout();
				this.handleInactivityTimeout(user);
			})
		);
	}

	private handleUserTimeout() {
		if (!this.sec.isLoggedOn() && this.isUrlNotBehindAuth()) {
			this.sec.setSecurity(null!, null!, null!);
			this.redirectToLogin();
		}
	}

	private redirectToLogin() {
		const redirectUrl = this.getRedirectUrl();
		if (redirectUrl == null || redirectUrl == "/login") {
			this.router.navigateByUrl(`/login`);
		} else {
			this.router.navigateByUrl(`/login?redirectUrl=${encodeURIComponent(redirectUrl)}`);
		}
	}

	private getRedirectUrl(): string | null {
		let redirect = globalThis.location.href.replace(document.getElementsByTagName('base')[0].href, '');
		if (decodeURIComponent(redirect).includes("login?redirectUrl=")) {
			redirect = "";
		}
		if (redirect !== null && redirect !== '' && redirect !== undefined) {
			return '/' + redirect;
		}
		return null;
	}

	private handleInactivityTimeout(user: any) {
		if (!user || !user.inactivityTimeout) {
			return;
		}

		if (!localStorage.getItem('lastAccess')) {
			this.sec.setSecurity(null!, null!, null!);
			return;
		}

		const lastAccessedDate = new Date(JSON.parse(localStorage.getItem('lastAccess')!));
		const endDate = addSeconds(addMinutes(lastAccessedDate, 4), 30);
		
		if (new Date() >= endDate && !this.modalOpen) {
			this.openInactivityModal();
		}
	}

	private openInactivityModal() {
		this.modalOpen = true;
		this.modal.dismissAll();
		this.modal.open(InactivityTimeoutComponent, {
			beforeDismiss: () => {
				this.modalOpen = false;
				return true;
			}
		});
	}

	isUrlNotBehindAuth() {
		return (
			!globalThis.location.href.includes('login') 
			&& !globalThis.location.href.includes('create-account') 
			&& !globalThis.location.href.includes('forgot-password') 
			&& !globalThis.location.href.includes('change-password') 
			&& !globalThis.location.href.includes('confirm-appointment') 
			&& !globalThis.location.href.includes('site-daily-count') //public page accessible via guid and email
			&& !globalThis.location.href.includes('opt-in-screenshots')
		);
	}

	stopTimer() { this.subsriptions.unsubscribe(); }
}
